module.exports = __webpack_public_path__ + "static/media/llogo.c47c16eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/llogo.svg
// module id = 942
// module chunks = 31